export const Flyout = 10000;
export const Tooltip = 1000002;
